module.exports = __webpack_public_path__ + "static/media/temp_4.406690ba.jpg";